import { makeStyles } from "@material-ui/styles";

export default makeStyles((theme) => ({
  title: {
    width: 161,
    height: 129,
  },
}));
